import { useMemo, useState } from "react";

import type { CompetitorOption, CompetitorValueMap } from "../types";

export const useCompetitorsSearch = (allCompetitorsValues: CompetitorValueMap) => {
    const [searchValue, setSearchValue] = useState("");

    const { primaryOptions, secondaryOptions } = useMemo(() => {
        const query = searchValue.toLowerCase();
        const primary: CompetitorOption[] = [];
        const secondary: CompetitorOption[] = [];

        allCompetitorsValues.forEach((option) => {
            if (query.length && !option.label.toLowerCase().includes(query)) {
                return;
            }

            if (option.kind === "secondary") {
                secondary.push(option);
            } else {
                primary.push(option);
            }
        });

        return { primaryOptions: primary, secondaryOptions: secondary };
    }, [allCompetitorsValues, searchValue]);

    return {
        searchValue,
        setSearchValue,
        primaryOptions,
        secondaryOptions,
    };
};
